import { AxiosResponse } from "axios";
import { userServiceApi } from "../../api";

type GetUserModulesResponse = {
  modules: string[];
};

export const userModules = (): Promise<
  AxiosResponse<GetUserModulesResponse>
> => {
  return userServiceApi.get("api/v1/users/modules");
};
